import { store } from '../../store'
import { httpgst } from '../../main'

// actions
const actions = {
  getTaxResults ({commit, dispatch}, payload) {
    // commit('onGetTaxResults', {event: payload.event})
    let url = 'api/verify-black-list/search-by-rfc/' + payload.event.taxID
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetTaxResults', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getGeneralResults ({commit, dispatch}, payload) {
    // commit('onGetGeneralResults', {event: payload.event})
    let url = 'api/verify-black-list'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetGeneralResults', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  downloadFiles ({commit, dispatch}, payload) {
    let url = 'api/zip-download'
    let params = {
      'expensesItems': [payload.event.item.id]
    }
    let config = {
      responseType: 'blob'
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, config)
      .then(
        response => {
          commit('onDownloadFiles', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

// mutations
const mutations = {
  onGetTaxResults (state, payload) {
    let result = payload.response.data.data ? payload.response.data.data.status : null
    if (result !== null) {
      payload.event.context.taxResult = payload.response.data.data
      payload.event.context.close()
      payload.event.context.taxWarning = true
      payload.event.context.taxSuccess = false
    } else {
      payload.event.context.taxResult = null
      payload.event.context.taxResult = payload.event.taxID
      payload.event.context.close()
      payload.event.context.taxWarning = false
      payload.event.context.taxSuccess = true
    }
  },
  onGetGeneralResults (state, payload) {
    // payload.event.context.blacklist = payload.response.data.data
    let cfdis = []
    let expenses = payload.response.data.data
    expenses.forEach(expense => {
      expense.gst_expenses_items.forEach(items => {
        items.user = expense.user
        cfdis.push(items)
      })
    })
    payload.event.context.blacklist = cfdis
    payload.event.context.cfdisTable = true
    payload.event.context.taxSuccess = false
    payload.event.context.taxWarning = false
    payload.event.context.close()
  },
  onDownloadFiles (state, payload) {
    payload.event.context.loading = false
    payload.event.context.forceFileDownload(payload.response.data, `${payload.event.item.uuid}.zip`)
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
    payload.event.context.close()
  }
}

export default {
  namespaced: true,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/verifyEFOS.js